import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const KineticLines = ({ lines, className = "", lineClassName = "" }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "115%" }}
          animate={{ y: 0 }}
          transition={{ duration: 1.05, delay: 0.25 + i * 0.16, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Chapter = ({ number, label }) => (
  <div className="flex items-center gap-4" data-testid={`chapter-${number}`}>
    <span className="font-serif italic text-gold text-xl leading-none">{number}</span>
    <span className="h-px w-10 bg-gold/60" aria-hidden="true" />
    <span className="uppercase text-[11px] tracking-[0.28em] font-bold text-navy/60">
      {label}
    </span>
  </div>
);
